export default {"src":"/_next/static/media/vkyc_fail.d70fa0d1.svg","height":220,"width":352,"blurWidth":0,"blurHeight":0};